export const MATCH_NOT_STARTED = 1;
export const MATCH_FINISHED = 2;
export const INTERMISSION = 3;
export const FULL_TIME = 4;
export const FIRST_EXTRA_ENDED = 5;
export const PENALTY_SERIES = 6;


// WEBPACK FOOTER //
// ./js/constants/MatchInfo.js